import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_MainSection = _resolveComponent("MainSection")!
  const _component_FooterSection = _resolveComponent("FooterSection")!
  const _component_BgBlobs = _resolveComponent("BgBlobs")!
  const _component_CursorBlob = _resolveComponent("CursorBlob")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createVNode(_component_MainSection),
    _createVNode(_component_FooterSection),
    _createVNode(_component_BgBlobs),
    _createVNode(_component_CursorBlob)
  ], 64))
}